import React, { useState, useEffect } from 'react'
import { CustomModalStyled, EduButton, isSEB } from '@edulastic/common'
import { forceLogout } from '@edulastic/api/src/utils/API'
import { greyDarken, titleColor } from '@edulastic/colors'
import { SEB_QUIT_URL } from '../../student/SebQuitConfirm'

function closeTab() {
  forceLogout()
  window.location.href = '/login'
}

function UserTokenExpiredModal() {
  // eslint-disable-next-line
  const isLoginPage = location?.pathname.includes('/login')
  const [showPopup, setShowPopup] = useState(false)

  const closePopupFn = () => {
    setShowPopup(false)
    if (isLoginPage) {
      if (isSEB()) {
        // in case of SEB, we need to redirect user to quit the SEB
        // reference - src/client/student/SebQuitConfirm/index.js#L36
        window.location.href = SEB_QUIT_URL
      }
      return
    }
    closeTab()
  }

  useEffect(() => {
    const showPopupFn = () => setShowPopup(true)
    window.addEventListener('user-token-expired', showPopupFn)
    return () => window.removeEventListener('user-token-expired', showPopupFn)
  }, [])

  return (
    <CustomModalStyled
      modalWidth="400px"
      modalMaxWidth="400px"
      title={
        <p style={{ fontSize: '20px', textAlign: 'center' }}>
          Session Expired!
        </p>
      }
      closable={false}
      maskClosable={false}
      centered
      onOk={closePopupFn}
      visible={showPopup}
      footer={[
        <div
          key="footer-content"
          style={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <EduButton width="120px" height="30px" onClick={closePopupFn}>
            OK
          </EduButton>
          <p
            style={{
              fontSize: '12px',
              color: greyDarken,
              margin: '15px 0 0 0',
              lineHeight: '1.4',
            }}
          >
            If you access this from a district
            <br />
            portal or app, sign in from there.
          </p>
        </div>,
      ]}
    >
      <p style={{ fontWeight: '500', textAlign: 'center', color: titleColor }}>
        You have been signed out. Please sign in again.
      </p>
    </CustomModalStyled>
  )
}

export default UserTokenExpiredModal
